export default __webpack_public_path__ + "locales/zh-CN/InviteDialog.json?hash=e3fb13295778b233d8c2d142a48201e5";